const initialState = {
    add_loading: false,
    get_loading: false,
    distributers: [],
};

export default function distributerReducer(
    state = initialState,
    { type, payload }
) {
    switch (type) {
        case "GET_DISTRIBUTER":
            return {
                ...state,
                distributers: payload,
            };
        case "GET_LOADER":
            return {
                ...state,
                get_loading: payload,
            };
        case "ADD_LOADER":
            return {
                ...state,
                add_loading: payload,
            };
        default:
            return {
                ...state,
            };
    }
}
